module.exports = __webpack_public_path__ + "img/hot-heart.1770dd78.png";